module.exports = __webpack_public_path__ + "img/header_1.c693a10a.jpg";